const PLAIN_NUMBER = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

/**
 * Value formatter for a chart that plots a plain count, share or duration —
 * NOT money. `VolumeBarChart` / `TrendLineChart` take a `valueFormatter` so a
 * chart does not ship a raw, unformatted hover number; choosing this one is the
 * explicit "this series is not currency" declaration. A chart that plots
 * money passes a currency formatter built on the shared `formatMoney`
 * (backoffice: `chartCentsFormatter` / `chartDollarsFormatter` in
 * `lib/chart-money.ts`) — never this.
 */
export function formatChartNumber(value: number): string {
  if (!Number.isFinite(value)) return '';
  const formatted = PLAIN_NUMBER.format(value);
  // A tiny negative (-0.001) rounds to "-0"; show "0".
  return formatted === '-0' ? '0' : formatted;
}
